import React from 'react';
import I18n from 'i18n-js';
import SanitizedRender from './sanitized_render';
import { RCPopover, RCIcon, useMediaQuery } from '@reverbdotcom/cadence/components';
import { InfoIcon } from '@phosphor-icons/react';
import { isMarketplacePage, REVERB_BUMP } from '../url_helpers';
import classNames from 'classnames';
import { useURL } from '../url_context';



export function BumpDSACompliancePopover() {
  const isDesktop = useMediaQuery('desktop') ?? true;
  const position = isDesktop ? 'right' : 'bottom-start';
  const url = useURL();
  const useUnderlinedLinkTreatment = isMarketplacePage(url);

  const classes = classNames({
    'mb-1 mt-1 pt-1': !useUnderlinedLinkTreatment,
  });
  const textStyle = classNames({
    'fg-color-text-secondary size-fixed-90': !useUnderlinedLinkTreatment,
  });
  const buttonClasses = classNames({
    'bump-dsa-compliance-popover--new': useUnderlinedLinkTreatment,
    'bump-dsa-compliance-popover': !useUnderlinedLinkTreatment,
  });

  return (
    <div className={classes}>
      <RCPopover
        position={position}
        anchor={
          <button type="button" className={buttonClasses}>
            <span className={textStyle}>
              {I18n.t('commons.bump.dsaCompliancePopover.title')}
            </span>
            {!useUnderlinedLinkTreatment &&
              <span className="fg-color-text-secondary size-fixed-100">
                <RCIcon icon={<InfoIcon />} size="inline" />
              </span>
            }
            <span className="visually-hidden">{I18n.t('commons.bump.dsaCompliancePopover.learnMore')}</span>
          </button>
        }
      >
        <SanitizedRender
          htmlTag="span"
          html={I18n.t('commons.bump.dsaCompliancePopover.description', {
            linkOpen: `<a href="${REVERB_BUMP}" target=_blank class="text-link" rel="nofollow">`,
            linkClose: '</a>',
          })}
        />
      </RCPopover>
    </div>
  );
}
